import { createFileRoute } from "@tanstack/react-router";

import { UnitsPage } from "../../../workspaces/robot-operations/UnitsPage";

export const Route = createFileRoute("/_console/operations/")({
  component: UnitsPage,
});
